import "../UserProfile.scss";
import { getUserDetails, UpdateuserProfile } from "../Services/UserProfile.sevice";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { EditProfileInitialValue, perosnalProfileSchema } from "../Schema/UserProfile.schema";
import { toast } from "react-hot-toast";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from "primereact/dropdown";
import { GENDER_OPTONS, COUNTRY_CODE } from "@Constants/app.constant";
import { getAllStatesList, getAllCityList } from "@Src/features/Auth/components/exam_prefrences/services/examPrefrences.service";
import { useAppDispatch } from "@Src/app/hooks";
import { showSpinner } from "@Src/app/reducers/globalSlice";
import { setUserFirtsName, setUserLastName, setUserNickname } from "@Src/app/reducers/auth/loginSlice";

export const EditProfileIndex = ({ setIsEdit, Userdetails }: any) => {

  // const [Userdetails, setuserdetails] = useState<any>([])
  const [editdata, seteditdata] = useState<Array<any>>([])
  const [stateList, setStateList] = useState<Array<any>>([]);
  const [cityList, setCityList] = useState<Array<any>>([]);
  const dispatch = useAppDispatch();

  let minDate = new Date('1899-01-01');
  let year = new Date().getFullYear() - 2
  let maxDate = new Date(`${year}-12-31`);
  let DOBYearRange = `1971:${year}`
  useEffect(() => {
    // getdetails()
    getStateList();
    setUserDetailsData(Userdetails);
  }, [])



  const { handleSubmit, handleChange, handleBlur, values, errors, touched, isValid, setFieldValue, setValues } = useFormik({
    initialValues: EditProfileInitialValue,
    validationSchema: perosnalProfileSchema,


    onSubmit: (e) => {
      updateprofile(e)

    }
  })

  useEffect(() => {
    if (values.stateId) {
      getCityList();
    }
  }, [values.stateId])


  // const getdetails = () => {
  //   getUserDetails().then((response: APIResponse) => {
  //     if (response.ResponseType === APIStatus.SUCCESS) {
  //       setUserDetailsData(response?.data[0])

  //     }
  //   }).catch((error: any) => {
  //     console.log(error)
  //   })
  // }

  function setUserDetailsData(userdetailsAPI: any) {
    setValues({
      FirstName: userdetailsAPI.FirstName ? userdetailsAPI.FirstName : '',
      LastName: userdetailsAPI.LastName ? userdetailsAPI.LastName : '',
      PhoneNo: userdetailsAPI?.PhoneNo,
      DOB: userdetailsAPI.DOB ? new Date(userdetailsAPI.DOB) : userdetailsAPI.DOB,
      Gender: userdetailsAPI.Gender ? userdetailsAPI.Gender : '',
      CityId: userdetailsAPI.cityId ? userdetailsAPI.cityId : null,
      stateId: userdetailsAPI.stateId ? userdetailsAPI.stateId : '',
      school: userdetailsAPI.School ? userdetailsAPI.School : '',
      countryCode: userdetailsAPI.CountryCode ? userdetailsAPI.CountryCode : '91',
      Nickname: userdetailsAPI.NickName ? userdetailsAPI.NickName : '',
      Address: userdetailsAPI.Address ? userdetailsAPI.Address : '',
      ParentEmailId: userdetailsAPI.ParentEmailId ? userdetailsAPI.ParentEmailId : '',
      ParentPhone: userdetailsAPI.ParentPhone ? userdetailsAPI.ParentPhone : '',
      ParentCountryCode: userdetailsAPI.ParentCountryCode ? userdetailsAPI.ParentCountryCode : '91'
    })
  }
  // setuserdetails((previous: any) => {
  //   return {
  //     ...previous,
  //     FirstName: userdetailsAPI?.FirstName,
  //     LastName: userdetailsAPI?.LastName,
  //     EmailId: userdetailsAPI?.EmailId,
  //     PhoneNo: userdetailsAPI?.PhoneNo,
  //     DOB: userdetailsAPI?.DOB,
  //     Gender: userdetailsAPI.Gender,
  //     city: userdetailsAPI.city,
  //     stateId: userdetailsAPI.stateId,
  //     school: userdetailsAPI.school,
  //     countryCode: userdetailsAPI.countryCode    
  //   };

  // });

  const formattedDate = (dob: any) => {
    const date = new Date(dob);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    let modifiedDate = [day, month, year].join('/');
    return date
    // setFieldValue('DOB', formattedDate)
  }
  // setValues({ PhoneNo: userdetailsAPI?.PhoneNo, DOB: formatDate() })


  const updateprofile = (e: any) => {
    const updateobj = {
      FirstName: e.FirstName,
      LastName: e.LastName,
      "DOB": e.DOB,
      "phoneNo": e.PhoneNo,
      Gender: e.Gender,
      CityId: e.CityId,
      stateId: e.stateId,
      school: e.school,
      countryCode: e.countryCode,
      NickName: e.Nickname,
      Address: e.Address,
      ParentEmailId: e.ParentEmailId,
      ParentPhone: e.ParentPhone,
      ParentCountryCode: e.ParentCountryCode
    }



    if (isValid && touched) {
      dispatch(showSpinner(true));
      UpdateuserProfile(updateobj).then((response: APIResponse) => {
        if (response.ResponseType === APIStatus.SUCCESS) {
          dispatch(setUserNickname(e.Nickname || ''));
          dispatch(setUserFirtsName(e.FirstName));
          dispatch(setUserLastName(e.LastName));
          dispatch(showSpinner(false));
          toast.success("User Details updated successfully")
          setIsEdit(false)
        } else {
          dispatch(showSpinner(false));
          toast.error(response.StatusMsg)
        }
      }).catch((error) => {
        dispatch(showSpinner(false));

      })
    }
  }

  const getStateList = async () => {
    getAllStatesList().then((response: APIResponse) => {
      if (response.ResponseType == APIStatus.SUCCESS) {
        setStateList(response.data);
      }
    })
      .catch((error) => {
        console.log(error);

      })
  }

  const getCityList = async () => {
    if (values.stateId) {
      let queryParams = {
        stateId: values.stateId
      }
      getAllCityList(queryParams).then((response: APIResponse) => {
        if (response.ResponseType == APIStatus.SUCCESS) {
          setCityList(response.data);
        }
      })
        .catch((error) => {
          console.log(error);
        })
    }
  }




  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="profile-input-card tw-rounded-2xl tw-shadow-lg tw-bg-white tw-m-0 tw-p-4 tw-mt-4" style={{ marginRight: "0px" }}>
          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-3">
            <div className="input-form-card">
              <div className="form-label-log">First Name <span className="mandiatory-star">*</span></div>
              <input
                type="text"
                name="FirstName"
                className="input-form-control"
                placeholder="Enter your first name"
                value={values.FirstName}
                onChange={handleChange}
                onBlur={handleBlur}
              // readOnly
              // disabled
              />
              {touched.FirstName && errors.FirstName ? (
                <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.FirstName}</p>
              ) : null}
            </div>
            <div className="input-form-card">
              <div className="form-label-log">Last Name <span className="mandiatory-star">*</span></div>
              <input
                type="text"
                name="LastName"
                className="input-form-control"
                placeholder="Enter your last name"
                value={values.LastName}
                onChange={handleChange}
                onBlur={handleBlur}
              // readOnly
              // disabled
              />
              {touched.LastName && errors.LastName ? (
                <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.LastName}</p>
              ) : null}
            </div>
            <div className="input-form-card">
              <div className="form-label-log pt-0">Nick Name</div>
              <input
                type="text"
                className="input-form-control"
                placeholder="Enter your nick name"
                value={values.Nickname}
                name="Nickname"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="input-form-card">
              <div className="form-label-log pt-0">Email Address <span className="mandiatory-star">*</span></div>
              <input
                type="text"
                className="input-form-control"
                placeholder="Enter your Email Address"
                value={Userdetails.EmailId}
                readOnly
                disabled
                style={{ backgroundColor: "#f3f4f6", color: "#6b7280" }}


              />
            </div>
            <div className="input-form-card">
              <div className="form-label-log pt-0">Parent Email Id</div>
              <input
                type="text"
                name="ParentEmailId"
                className="input-form-control"
                placeholder="Enter parent email id"
                value={values.ParentEmailId}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {touched.ParentEmailId && errors.ParentEmailId ? (
                <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.ParentEmailId}</p>
              ) : null}
            </div>
            <div className="input-form-card">
              <div className="form-label-log pt-0">Parent Mobile Number</div>
              <div className="tw-flex tw-flex-col sm:tw-flex-row tw-items-stretch sm:tw-items-center tw-gap-2">
                <div className="tw-flex-shrink-0 tw-w-full sm:tw-w-24">
                  <Dropdown
                    className="select-form-control tw-p-1.5 tw-w-full"
                    value={values.ParentCountryCode}
                    name="ParentCountryCode"
                    onChange={handleChange}
                    options={COUNTRY_CODE}
                    optionLabel="Name"
                    optionValue="Value"
                    appendTo="self"

                  />
                </div>
                <input
                  type="text"
                  name="ParentPhone"
                  className="input-form-control tw-flex-1 tw-mt-0"
                  placeholder="Enter parent phone number"
                  value={values.ParentPhone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength={10}
                  onKeyDown={(e) => {


                    if (
                      !/[0-9]/.test(e.key) &&
                      e.key !== "Backspace" &&
                      e.key !== "ArrowLeft" &&
                      e.key !== "ArrowRight" &&
                      e.key !== "Tab"
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
              {touched.ParentPhone && errors.ParentPhone ? (
                <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.ParentPhone}</p>
              ) : null}
            </div>


          </div>

          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-4 tw-gap-3">
            <div className="input-form-card tw-col-span-1 lg:tw-col-span-2">
              <div className="form-label-log"> Mobile Number <span className="mandiatory-star">*</span></div>


              <div className="tw-flex tw-flex-col sm:tw-flex-row tw-items-stretch sm:tw-items-center tw-gap-2">
                <div className="tw-flex-shrink-0 tw-w-full sm:tw-w-24">
                  {/* <select className="select-form-control tw-p-0">
                    <option >+91</option>
                  </select> */}
                  <Dropdown
                    className="select-form-control tw-p-1.5 tw-w-full"
                    value={values.countryCode}
                    name="countryCode"
                    onChange={handleChange}
                    options={COUNTRY_CODE}
                    optionLabel="Name"
                    optionValue="Value"
                    appendTo="self"
                    disabled={Userdetails.RegisteredFrom === 'mobile'}
                    style={{ backgroundColor: Userdetails.RegisteredFrom === 'mobile' ? "#f3f4f6" : '', color: Userdetails.RegisteredFrom === 'mobile' ? "#6b7280" : '' }}
                  />
                </div>

                <input
                  type="text"
                  className="input-form-control tw-flex-1 tw-mt-0"
                  placeholder="Enter your Mobile number"
                  value={values.PhoneNo}
                  name='PhoneNo'
                  maxLength={10}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onKeyDown={(e) => {


                    if (
                      !/[0-9]/.test(e.key) &&
                      e.key !== "Backspace" &&
                      e.key !== "ArrowLeft" &&
                      e.key !== "ArrowRight" &&
                      e.key !== "Tab"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  disabled={Userdetails.RegisteredFrom === 'mobile'}
                  style={{ backgroundColor: Userdetails.RegisteredFrom === 'mobile' ? "#f3f4f6" : '', color: Userdetails.RegisteredFrom === 'mobile' ? "#6b7280" : '' }}
                />
              </div>
              {touched.PhoneNo && errors.PhoneNo ? (
                <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.PhoneNo}</p>
              ) : null}


            </div>

            <div className="input-form-card tw-col-span-1">
              <div className="form-label-log">Date of Birth <span className="mandiatory-star">*</span></div>
              <Calendar className="Dob-calendar" value={values.DOB} onChange={(e) => { handleChange(e), setFieldValue('DOB', e.value) }} showIcon={true}
                minDate={minDate} maxDate={maxDate} dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy"
                yearRange={DOBYearRange} yearNavigator
                appendTo="self"
              />
              {touched.DOB && errors.DOB ? (
                <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.DOB}</p>
              ) : null}
            </div>
            <div className="input-form-card tw-col-span-1">
              <div className="form-label-log">Gender <span className="mandiatory-star">*</span></div>
              <Dropdown
                className="prime-deopdown tw-p-1.5"
                placeholder="Please select your gender"
                value={values.Gender}
                name="Gender"
                onChange={(e) => { handleChange(e), setFieldValue('Gender', e.value) }}
                options={GENDER_OPTONS}
                optionLabel="Name" optionValue="Id"
                appendTo="self"
              />
              {touched.Gender && errors.Gender ? (
                <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.Gender}</p>
              ) : null}
            </div>

          </div>

          <div className="input-form-card">
            <div className="form-label-log">School Name <span className="mandiatory-star">*</span></div>
            <input
              type="text"
              className="input-form-control"
              placeholder="Enter your school name"
              value={values.school}
              onChange={(e) => { handleChange(e), setFieldValue('school', e.target.value) }}
            />
            {touched.school && errors.school ? (
              <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.school}</p>
            ) : null}
          </div>


          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-3">
            <div className="tw-col-span-1 lg:tw-col-span-3">
              <div className="input-form-card">
                <div className="form-label-log">Street Address</div>
                <textarea
                  className="input-form-control"
                  placeholder="Enter your street address"
                  value={values.Address}
                  name="Address"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  rows={4}
                  style={{ resize: "none" }}
                />
              </div>
            </div>
            <div className="tw-col-span-1">
              <div className="input-form-card">
                <div className="form-label-log">State <span className="mandiatory-star">*</span></div>
                <Dropdown
                  className="prime-deopdown tw-p-1.5"
                  placeholder="Please select your state"
                  value={values.stateId}
                  name="boardListId"
                  onChange={(e) => {
                    handleChange(e);
                    setFieldValue('stateId', e.value);
                    setFieldValue('CityId', null);
                  }}
                  options={stateList}
                  optionLabel="Name" optionValue="Id"
                  appendTo="self"

                />
                {touched.stateId && errors.stateId ? (
                  <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.stateId}</p>
                ) : null}
              </div>
            </div>
            <div className="tw-col-span-1">
              <div className="input-form-card">
                <div className="form-label-log">City <span className="mandiatory-star">*</span>
                </div>
                <Dropdown
                  className="prime-deopdown tw-p-1.5"
                  placeholder="Please select your city"
                  value={values.CityId}
                  name="CityId"
                  onChange={(e) => { handleChange(e), setFieldValue('CityId', e.value) }}
                  options={cityList}
                  optionLabel="Name" optionValue="Id"
                  disabled={!values.stateId}
                  appendTo="self"
                />
                {touched.CityId && errors.CityId ? (
                  <p className="tw-text-red-500 tw-text-sm tw-mt-2 tw-ml-1">{errors.CityId as any}</p>
                ) : null}
              </div>
            </div>
            {/* <div>
              <div className="input-form-card">
                <div className="form-label-log">Zip</div>
                <input
                  type="text"
                  className="input-form-control"
                  placeholder="Enter your last name"
                  value=""
                  readOnly
                  disabled
                />
              </div>
            </div> */}




          </div>



          <div className="tw-text-center tw-mt-9 tw-flex tw-flex-col sm:tw-flex-row tw-justify-center tw-gap-3">
            <button type="button" onClick={() => setIsEdit(false)} className="ia-btn ia-btn-outline-primary tw-px-3 tw-w-full sm:tw-w-auto tw-order-2 sm:tw-order-1">Go Back</button>
            <button className="ia-btn ia-btn-primary tw-px-3 tw-w-full sm:tw-w-auto tw-order-1 sm:tw-order-2" type="submit" >Save & Continue </button>
          </div>
        </div>
      </form>
    </>
  );
};